import usersEditComponent from './users.edit.component';

let usersEditModule = angular.module('usersedit', [
])

.component('usersedit', usersEditComponent)

.name;

export default usersEditModule;


// WEBPACK FOOTER //
// ./client/app/components/users/edit/index.js